<template>
  <div id="progress" class="progress">
    <div class="step" :style="{ width: percent + '%' }">
      <div class="round-sign">
        <div v-if="percent !== 100" class="round-sign-text">
          {{ startMoney }}
          元
        </div>
      </div>
    </div>
    <div class="roune-end">
      <div class="end-rewards">
        <div class="value">
          {{ `¥ ${rewards}` }}
        </div>
      </div>
      <div class="end-money">
        {{ endMoney }}
        元
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MoneyProgress',
  props: {
    startMoney: {
      type: Number,
      default: 0
    },
    endMoney: {
      type: Number,
      default: 0
    },
    rewards: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      percent: 0
    }
  },
  watch: {
    startMoney() {
      this.calculatePercent()
    }
  },
  mounted() {
    this.calculatePercent()
  },
  methods: {
    calculatePercent() {
      let percent = (this.startMoney / this.endMoney) * 100
      percent =
        percent > 88
          ? percent >= 100
            ? 100
            : 88
          : percent === 0
          ? 0
          : Math.max(percent, 10)
      setTimeout(() => {
        this.percent = percent
      }, 300)
    }
  }
}
</script>
<style lang="scss" scoped>
.progress {
  position: relative;

  width: 5.4rem;
  height: 0.3rem;
  margin: 0.48rem 1rem 0 0.72rem;

  border-radius: 0.3rem;

  border: 1px solid #ffd4a9;

  white-space: nowrap;
  box-sizing: border-box;
}
.step {
  position: absolute;
  top: -0.02rem;
  left: 0;

  min-width: 0.3rem;
  height: 0.3rem;

  background-color: #ffd5aa;
  border-radius: 0.3rem;
  border: 1px solid #ffd4a9;
  box-sizing: border-box;

  transition: width 2.5s ease;
  .round-sign {
    position: absolute;
    top: -0.02rem;
    right: -0.02rem;

    width: 0.3rem;
    height: 0.3rem;

    background-color: #fe9603;
    border-radius: 50%;
    .round-sign-text {
      position: absolute;
      top: 0.48rem;
      left: 50%;
      transform: translateX(-50%);

      font-size: 0.24rem;
      color: #333;
    }
  }
}
.roune-end {
  position: absolute;
  top: 0;
  right: 0;
  .end-money {
    position: absolute;
    top: 0.46rem;
    left: 50%;
    transform: translateX(-50%);

    font-size: 0.24rem;
    color: #333;
  }
}
.end-rewards {
  position: absolute;
  top: -0.5rem;
  left: 50%;
  transform: translateX(-50%);

  width: 0.8rem;
  height: 0.78rem;

  background-image: url('../images/jinbi.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .value {
    width: 0.8rem;
    height: 0.3rem;
    margin-top: 0.48rem;

    font-size: 0.24rem;
    line-height: 0.32rem;
    text-align: center;
    color: #fff;
  }
}
</style>
